export default {
    'name': 'similar',
    'label': 'growth.SimilarPatent.similar',
    'getComponent': () => import('./similar.vue'),
    'tabIndex': 9,
    'left': true,
    'right': true,
    'singleView': true,
    'exclusiveRoutePath': '/similar',
    'aclCheckKey': 'mlt',
};
